/**
 * DOM Matrix.
 *
 * TODO: Not fully implemented.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix
 */
export default class DOMMatrix {
	public readonly is2D = false;
	public readonly isIdentity = false;
}
